<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { fade } from "svelte/transition";
  import { circInOut } from "svelte/easing";
  import { onDestroy, onMount } from "svelte";
  export let open: boolean;
  export let closeLabel: string;

  const dispatcher = createEventDispatcher();

  let modal: HTMLDivElement;

  function handleKeydown(e: KeyboardEvent) {
    if (e.key === "Escape") close();
  }

  function close() {
    if (open) {
      dispatcher("close");
      open = false;
    }
  }

  let parent: Element;
  onMount(() => {
    parent = modal.parentElement;
    document.body.append(modal);
  });
  onDestroy(() => parent.append(modal));
</script>

<svelte:window on:keydown={handleKeydown} />

<div bind:this={modal}>
  {#if open}
    <div class="lrs-modal-overlay lrs-datepicker-zindex" on:click|self={(_) => close()} transition:fade={{ duration: 200, easing: circInOut }}>
      <div class="lrs-modal">
        <slot />
        <div class="lrs-modal-actions">
          <button class="bs3-btn bs3-btn-primary lrs-modal-close" on:click={(_) => close()}>{closeLabel}</button>
        </div>
      </div>
    </div>
  {/if}
</div>

<style lang="scss" global>
  .lrs-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(#000, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .lrs-modal {
    position: relative;
    max-width: calc(100% - 1em);
    max-height: calc(100% - 1em);
    box-sizing: content-box;
    border-radius: 28px;
    padding: 0.5rem;
    background-color: #fff;
    box-shadow: 0px 2px 35px -2px rgb(0 0 0 / 15%);
  }

  .lrs-modal-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
    padding: 0.5rem;
  }

  :where(.lrs-modal-close) {
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    background-color: #ffbc00;
    border: 1px solid #ffbc00;
    color: #000;
    padding: 0.5rem 1.5rem;
    font-size: 1rem;
    border-radius: 9999px;

    &:where(:hover) {
      background-color: #d9a000;
      border-color: #cc9600;
    }

    &:where(&:focus) {
      background-color: #d9a000;
      border-color: #000;
      box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 0 1px #000;
    }

    &:where(&:active) {
      background-color: #cc9600;
      border-color: #bf8d00;
    }
  }
</style>
